// extracted by mini-css-extract-plugin
export var container = "transition-gallery-module--container--TDp8i";
export var errorText = "transition-gallery-module--error-text--pVNuS";
export var grid = "transition-gallery-module--grid--J0mus";
export var loader = "transition-gallery-module--loader--rp62S";
export var loading = "transition-gallery-module--loading--DZJS1";
export var noItems = "transition-gallery-module--no-items--p4lzJ";